import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function listLeadsWindows(): Promise<{
  data: Array<import('../models/LeadsWindowModel').LeadsWindowModel>;
}> {
  return axios.get(`${API_URL}/api/crm/leads-windows/`);
}
